import { render, staticRenderFns } from "./OrderInfoDialogBase.vue?vue&type=template&id=fa39faf8&scoped=true&"
import script from "./OrderInfoDialogBase.vue?vue&type=script&lang=js&"
export * from "./OrderInfoDialogBase.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoDialogBase.vue?vue&type=style&index=0&id=fa39faf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa39faf8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
